// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function compose(fn1, ...fns) {
  return fns.reduce((prevFn, nextFn) => {
    return (value) => {
      return prevFn(nextFn(value))
    }
  }, fn1)
}
